import React, { Component } from 'react';
import { formatCurrency } from '@C/TableGrid';

class FuelSales extends Component {
  constructor() {
    super();
    this.state = {
      list: [],
    };
  }

  render() {
    const summary = this.props.summary;
    return (
      <>
        <section className="widget dsr-table">
          <header></header>
          <main>
            <table className="dsr" data-name="Fuel Sales">
              <thead>
                <tr>
                  <th colSpan={3} className="alert-brand">
                    {' '}
                    Fuel Sales
                  </th>
                </tr>
                <tr data-header={true}>
                  <th> Product </th>
                  <th>Quantity </th>
                  <th>Amount</th>
                </tr>
              </thead>
              <tbody>
                {summary.map((item, key) => {
                  return (
                    <tr key={key}>
                      <td>{item.product}</td>
                      <td>{item.litters_sold.toFixed(2)}</td>
                      <td>{formatCurrency(item.fuel_product_sale || 0)}</td>
                    </tr>
                  );
                })}
                <tr className="summary-row">
                  <td colSpan="2">Total </td>
                  <td>
                    {formatCurrency(
                      summary.reduce(
                        (a, b) => a + (b['fuel_product_sale'] || 0),
                        0,
                      ) || 0,
                    )}
                  </td>
                </tr>
              </tbody>
            </table>
          </main>
        </section>
      </>
    );
  }
}

export default FuelSales;
